import { SideMenuWrapper as SideMenu } from "./SideMenuWrapper";

export { SideMenu };
